module.exports = "//public.zight.com/packs/media/images/pattern-4-5cb383ec8849dde6d046c6cd035aa43c.png";